import { render, staticRenderFns } from "./UIError.vue?vue&type=template&id=3dd7d582&scoped=true"
import script from "./UIError.vue?vue&type=script&lang=js"
export * from "./UIError.vue?vue&type=script&lang=js"
import style0 from "./UIError.vue?vue&type=style&index=0&id=3dd7d582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7d582",
  null
  
)

export default component.exports